<script setup lang="ts">
  import { ref } from 'vue'
  import NeedHelpModalQC from './components/NeedHelpModalQC/NeedHelpModalQC.vue'
  import NeedHelpButtonQC from './components/NeedHelpButtonQC/NeedHelpButtonQC.vue'
  import { useFlow, useFlowSteps, useGoogleAnalytics } from '@/shared/composables'
  import { useRoute } from 'vue-router'

  const gaService = useGoogleAnalytics()
  const flow = useFlow()
  const route = useRoute()
  const flowStep = useFlowSteps(flow.flowScheme)
  const popupShown = ref<boolean>(false)

  const onShowHelpPopup = () => {
    popupShown.value = true
    gaService.sendContactUsPopup(flowStep.step.value.current || route.name)
  }
</script>

<template>
  <NeedHelpButtonQC @click="onShowHelpPopup" />
  <NeedHelpModalQC
    v-if="popupShown"
    :page="flowStep.step.value.current"
    data-test="need-help-widget"
    @close="popupShown = false"
  />
</template>
